var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQueryStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m89-249-49-36 188-300 119.571 140L507-703l109 162q-16 2-31 6.5T555-524l-45-69-152.557 249L236-485 89-249ZM877-40 743-174q-21 15-45.5 23t-50.5 8q-70.833 0-120.417-49.618Q477-242.235 477-313.118 477-384 526.618-433.5q49.617-49.5 120.5-49.5Q718-483 767.5-433.417 817-383.833 817-313q0 26-8.5 50.5T786-215.552L920-83l-43 43ZM646.859-203Q693-203 725-234.859q32-31.859 32-78T725.141-391q-31.859-32-78-32T569-391.141q-32 31.859-32 78T568.859-235q31.859 32 78 32ZM721-531q-15-6-31-8t-33-4l214-337 49 36-199 313Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryStats);
export default __webpack_public_path__ + "static/media/query_stats.887b073fcf779ae645c69e67b3961257.svg";
export { ForwardRef as ReactComponent };